import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { massUpdateTrapSkuPresence } from "../services/trapSkuService";
import { useErrorStore } from "components";

// Глобальний стор (state manager) для режиму вибору SKU
export const useTrapsSelectionStore = create(
  persist(
    (set, get) => ({
      isSelectionModeActive: false,
      selectedSkus: [],
      isLoading: false,

      // Переключення режиму вибору SKU
      toggleSelectionMode: () =>
        set((state) => {
          const newMode = !state.isSelectionModeActive;
          return {
            isSelectionModeActive: newMode,
            selectedSkus: newMode ? state.selectedSkus : [],
          };
        }),

      // Додавання або видалення одного SKU (toggle)
      toggleSku: (sku) =>
        set((state) => {
          const isSelected = state.selectedSkus.includes(sku);
          if (isSelected) {
            return { selectedSkus: state.selectedSkus.filter((s) => s !== sku) };
          } else {
            return { selectedSkus: [...state.selectedSkus, sku] };
          }
        }),

      // Функція для "Обрати всі" (приймає масив всіх SKU на поточній сторінці)
      selectAll: (allSkusOnPage) => {
        set((state) => {
          // Перевіряємо, чи всі вже обрані
          const allSelected = allSkusOnPage.every((sku) =>
            state.selectedSkus.includes(sku)
          );

          if (allSelected) {
            // інакше - виділяємо всі
            return {
              selectedSkus: state.selectedSkus.filter(
                (s) => !allSkusOnPage.includes(s)
              ),
            };
          } else {
            // Якщо так - знімаємо виділення
            const newSet = new Set([...state.selectedSkus, ...allSkusOnPage]);
            return { selectedSkus: Array.from(newSet) };
          }
        });
      },

      // Масове оновлення статусу
      updatePresenceForSelected: async (presenceStatus) => {
        const { selectedSkus } = get();
        if (selectedSkus.length === 0) return;

        set({ isLoading: true });
        try {
          const response = await massUpdateTrapSkuPresence(
            selectedSkus,
            presenceStatus
          );

          // Cкидаємо вибір після успішного оновлення
          get().resetState();

          return response;
        } catch (error) {
          const { showError } = useErrorStore.getState();
          showError(`Не вдалося оновити статус: ${error.message}`);
          console.error("Помилка масового оновлення:", error);
          throw error;
        } finally {
          set({ isLoading: false });
        }
      },

      // Скидання стану (викликається при Unmount компонента)
      resetState: () =>
        set({
          isSelectionModeActive: false,
          selectedSkus: [],
          isLoading: false,
        }),
    }),
    {
      name: "traps-selection-storage", // Унікальне ім'я ключа в localStorage
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        // Зберігаємо ТІЛЬКИ ці поля (щоб не зберігати isLoading і т.д.)
        selectedSkus: state.selectedSkus,
        isSelectionModeActive: state.isSelectionModeActive,
      }),
    }
  )
);
